import { render } from "./CalculatorTier.vue?vue&type=template&id=73af879b&ts=true"
import script from "./CalculatorTier.vue?vue&type=script&lang=ts"
export * from "./CalculatorTier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__